import { render, staticRenderFns } from "./AdmissionExam.vue?vue&type=template&id=332063a7&"
import script from "./AdmissionExam.vue?vue&type=script&lang=ts&"
export * from "./AdmissionExam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332063a7')) {
      api.createRecord('332063a7', component.options)
    } else {
      api.reload('332063a7', component.options)
    }
    module.hot.accept("./AdmissionExam.vue?vue&type=template&id=332063a7&", function () {
      api.rerender('332063a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/AdmissionExam.vue"
export default component.exports